<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="line-icon">
    <path d="M5 21V4M5 4h11l-2 4 2 4H5" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#4555CC',
    },
  },
};
</script>

<style lang="scss" scoped>
.line-icon {
  flex: none;
}
</style>
